module.exports = function(PluginManager) {
  PluginManager.registerDependency('sources/browser_id', require('./sources/browser_id'));
  PluginManager.registerVisitorProfileProvider(require('./providers/browser_id'));
  PluginManager.registerVisitorProfileProvider(require('./providers/browser_version'));
  PluginManager.registerAudienceMatcher('browser_version', require('./matchers/browser'));
};
